import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import useStore from '../../../store';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';
import { useStepHook } from '../logic/useStepHook';
import { StepView } from './StepView';

import { ChangePhoneReturn, useChangePhoneMutation } from '../logic/useChangePhoneMutation';
import { ApiError } from '../ChangePhone';
import { formatPhoneNum } from '../../../services/phoneNumber.service';

export interface ChangePhoneProps {
  onClose: () => void;
}

export const PhoneStep = ({ onClose }: ChangePhoneProps) => {
  const { data, t, customerId, handleErrorCode } = useStepHook();
  const { apiResponseData } = data;
  const setAccountSummary = useStore((state) => state.setSummary);

  const onError = useCallback((error: ApiError) => {
    handleErrorCode(error);
  }, []);
  const handleSuccess = useCallback(
    (apiData: ChangePhoneReturn) => {
      setAccountSummary({
        ...useStore.getState().summary,
        customer: {
          ...useStore.getState().summary.customer,
          phoneNumber: apiData.newPhoneNumber,
        },
      });
      const formattedPhoneValue = formatPhoneNum(apiData.newPhoneNumber);

      onClose();
      toast(
        <LiliNotification
          type={LiliNotificationType.SUCCESS}
          title={t('CHANGE_PHONE.SUCCESS.TITLE')}
          text={t('CHANGE_PHONE.SUCCESS.DESCRIPTION') + formattedPhoneValue}
          id='change-phone-success-notification'
        />,
        {
          ...LiliToastDefaultConfig,
          position: toast.POSITION.BOTTOM_CENTER,
          closeOnClick: false,
          autoClose: false,
          // closeButton: false,
        },
      );
    },
    [onClose],
  );
  const { isLoading, mutate: mutatePhoneNumber } = useChangePhoneMutation(handleSuccess, onError);

  const handleConfirm = useCallback(
    (value: string) => {
      mutatePhoneNumber({ newPhoneNumber: value, stateToken: apiResponseData.stateToken, customerId });
    },
    [apiResponseData],
  );

  return (
    <StepView
      title={t('CHANGE_PHONE.PHONE.TITLE')}
      headLineSmallText={t('CHANGE_PHONE.PHONE.SUB_HEADER')}
      buttonTitle={t('CHANGE_PHONE.BUTTON_TITLE')}
      handleClick={handleConfirm}
      numOfDigits={6}
      isLoading={isLoading}
    />
  );
};
